import configuratorManualAdmHtml from './configuratorManualAdm.html';
import materialsService from './../materials/materials.service';
import Validator from './../configurator/validator';

class configuratorManualAdmController {
    constructor($scope, $timeout, $http, materialsService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$http = $http;
        this.materialsService = materialsService;
        this.translate = translateService;

        this.threadId = false;
        this.materials = [];
        this.threadOrderStatuses = [];
        this.thread = {};
        this.products = [];
        this.currentTimestamp = Math.floor(Date.now() / 1000);
        this.message = '';
        this.loading = true;
        this.error = false;
        this.success = false;

        this.loadMaterials();

        this.loadThreadOrderStatuses();
    }

    loadMaterials() {
        this.materialsService.getMaterials().then((response) => {
            for (let material of response.data) {
                material.available = true;
                if (material.image !== null) {
                    material.image = material.image.src || null;
                } else {
                    material.image = null;
                }
            }

            this.materials = response.data;

            this.$scope.$watch(() => this.threadId, (newVal, oldVal) => {
                if (newVal === null) {
                    $timeout(() => {
                        this.loading = false;
                    }, 500);

                    return;
                }

                this.loadThread();
            });
        });
    }

    loadThreadOrderStatuses() {
        this.$http.get(
            `/admpanel/ajax/configurator/manual/getThreadOrderStatuses`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.threadOrderStatuses = response.data;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadThread() {
        this.$http.get(
            `/admpanel/ajax/configurator/manual/getThread/${this.threadId}`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.thread = response.data.thread;
                    Validator.setMaterialsMaxDimensions(this.materials, this.thread.shop_id);
                    this.loadProducts();
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadProducts() {
        this.$http.get(
            `/admpanel/ajax/configurator/manual/getProducts/${this.threadId}`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.products = response.data.products;

                    this.setProductsMaterials();
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    setProductsMaterials() {
        for (let product of this.products) {
            this.setProductMaterial(product);
        }
    }

    setProductMaterial(tmpProduct) {
        for (let product of [tmpProduct]) {
            product.cutModeMessage = null;
            product.dimensionsWidthMessage = null;
            product.dimensionsHeightMessage = null;

            if (product.material_id) {
                product.init_material_id = product.material_id;
                product.init_material_subtype_id = product.material_subtype_id;
                product.init_material_size_id = product.material_size_id;

                const activeMaterialType = this.materials.filter(material => material.id === product.init_material_id);
                if (activeMaterialType.length > 0) {
                    this.changeMaterialType(product, activeMaterialType[0]);
                } else {
                    this.changeMaterialType(product, this.materials[0]);
                }

                if (product.init_material_subtype_id && product.activeMaterial && product.activeMaterial.items.length > 0) {
                    for (const subType of product.activeMaterial.items) {
                        if (subType.id != product.init_material_subtype_id) {
                            continue;
                        }

                        this.changeMaterialSubType(product, subType);

                        if (product.init_material_size_id && product.activeSubType && product.activeSubType.items.length > 0) {
                            for (const size of product.activeSubType.items) {
                                if (size.id != product.init_material_size_id) {
                                    continue;
                                }

                                this.changeMaterialSize(product, size);

                                break;
                            }
                        }

                        break;
                    }

                    continue;
                }

                if (product.init_material_size_id && product.activeMaterial && product.activeMaterial.items.length > 0) {
                    for (const size of product.activeMaterial.items) {
                        if (size.id != product.init_material_size_id) {
                            continue;
                        }

                        this.changeMaterialSize(product, size);

                        break;
                    }
                }
            } else {
                this.changeMaterialType(product, this.materials[0]);
            }
        }
    }

    changeMaterialType(product, value) {
        product.activeMaterial = value;
        product.activeSubType = null;
        product.activeSize = null;

        if (value.items && value.items.length > 0) {
            if (value.items[0].items && value.items[0].items.length > 0) {
                product.activeSubType = value.items[0];
                product.activeSize = value.items[0].items[0];
            } else {
                product.activeSize = value.items[0];
            }
        }

        product.material_id = product.activeMaterial !== null ? product.activeMaterial.id : null;
        product.material_subtype_id = product.activeSubType !== null ? product.activeSubType.id : null;
        product.material_size_id = product.activeSize !== null ? product.activeSize.id : null;

        this.changeCutMode(product);
    }

    changeMaterialSubType(product, value) {
        product.activeSubType = value;
        product.activeSize = product.activeSubType.items[0];

        product.material_subtype_id = product.activeSubType !== null ? product.activeSubType.id : null;
        product.material_size_id = product.activeSize !== null ? product.activeSize.id : null;

        this.changeCutMode(product);
    }

    changeMaterialSize(product, value) {
        product.activeSize = value;

        product.material_size_id = product.activeSize !== null ? product.activeSize.id : null;
    }

    getProductId(index) {
        return String.fromCharCode('A' . charCodeAt() + index);
    }

    addNewProduct() {
        const index = this.products.length;

        let statusId = 0;

        if (!('user_id' in this.thread) || this.thread.user_id === null) {
            statusId = 1;
        }

        this.products.push({
            id: null,
            letter_id: this.getProductId(index),
            manual_configurator_thread_id: this.products[0].manual_configurator_thread_id,
            status: statusId,
            product_name_status: 0,
            product_name: '',
            price_status: 0,
            suggested_price_net: null,
            suggested_price_gros: null,
            suggested_percent: null,
            width: null,
            height: null,
            depth: null,
            material_id: 1,
            material_subtype_id: 2,
            material_size_id: 3,
            cut_mode: "",
            cut_line: null,
            thickness: 1.19,
            quantity: 1,
            user_file_name: null,
            file_name: null,
            offered_at: null,
            created_at: null,
            activeMaterial: null,
            activeSubType: null,
            activeSize: null,
            new_file_name: null
        });

        this.setProductMaterial(this.products[index]);
    }

    changeDone() {
        this.loading = true;

        if (this.thread.editable) {
            this.$http.get(
                `/admpanel/ajax/configurator/manual/changeDone/${this.thread.id}/${this.thread.done}`
            ).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === 'error') {
                        this.error = response.data.message;
                        $('html,body').animate({ scrollTop: 0 }, 'slow');

                        this.$timeout(() => {
                            this.error = false;
                        }, 5000);
                    } else {
                        this.success = this.translate.t('admpanel.manualConfigurator.executionStatusOfCustomQueryHasChanged');
                        $('html,body').animate({ scrollTop: 0 }, 'slow');

                        this.$timeout(() => {
                            this.success = false;
                        }, 5000);

                        this.complaint = response.data.complaint;
                    }
                },
                () => {
                    this.loading = false;

                    this.error = this.translate.t('admpanel.general.unexpectedErrorHasOccurred');
                    $('html,body').animate({ scrollTop: 0 }, 'slow');

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                }
            );
        }
    }

    cancel(product, index) {
        this.loading = true;

        this.$http.get(`/admpanel/ajax/configurator/manual/threadCancel/${this.threadId}/${product.id}`).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.products[index].status = response.data.status;

                    this.thread.done = response.data.threadDone;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    saveParametersAndCalculatePrice(product, index) {
        this.loading = true;

        const formData = new FormData();

        if (product.new_file_name) {
            formData.append('file', product.new_file_name.fileFormData.get('file'));
            product.new_file_name = null;
        }

        formData.append('product', JSON.stringify(product));

        this.$http.post(`/admpanel/ajax/configurator/manual/threadOfferPrice/${this.threadId}/${product.id}`, formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.products[index].suggested_price_net = response.data.suggested_price_net;
                    this.products[index].suggested_percent = response.data.suggested_percent;
                    this.products[index].file_name = response.data.file_name;
                    this.products[index].new_file_name = null;
                    this.products[index].id = response.data.thread_order_id;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    setStatusCalculated(product, index) {
        this.loading = true;

        this.$http.get(`/admpanel/ajax/configurator/manual/threadOffer/${this.threadId}/${product.id}`).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.products[index].status = response.data.status;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    canNotifyUser() {
        let returnValue = false;

        for (let product of this.products) {
            if (product.suggested_price_net !== null && product.suggested_price_net > 0 && (product.status == 1 || product.status == 3)) {
                returnValue = true;
                break;
            }
        }

        return returnValue;
    }

    notifyUser() {
        this.loading = true;

        this.$http.get(`/admpanel/ajax/configurator/manual/notifyUser/${this.threadId}`).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.thread.done = response.data.thread.done;
                    this.thread.user_notified_at = response.data.thread.user_notified_at;
                    this.thread.user_notified_by_admin_id = response.data.thread.user_notified_by_admin_id;
                    this.thread.admin = response.data.thread.admin;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    changeCalculatedPrice(product, index) {
        this.loading = true;

        this.$http.post(`/admpanel/ajax/configurator/manual/threadOfferPriceChange/${this.threadId}/${product.id}`, {price_status: product.price_status, suggested_price_net: product.suggested_price_net}).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.products[index].suggested_price_net = response.data.suggested_price_net;
                    this.products[index].suggested_percent = response.data.suggested_percent;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    nullableSuggestedPercent(index) {
        this.products[index].suggested_percent = null;
    }

    changeCutMode(product) {
        product.cutModeMessage = null;

        switch (product.activeMaterial.name) {
            case this.translate.t('admpanel.materials.pbb'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                if (product.activeSubType !== null && product.activeSubType.name === 'Bloki') { // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie frezarką
                    if (product.cut_mode === 'laser') {
                        product.cutModeMessage = this.translate.t('admpanel.manualConfigurator.cutChain').toLowerCase() + ', ' + this.translate.t('admpanel.manualConfigurator.cutChainPolished').toLowerCase() + ', ' + this.translate.t('admpanel.manualConfigurator.cutFrez').toLowerCase();
                    }
                }
                break;
            case this.translate.t('admpanel.materials.pEco'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pop'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pCzarna'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pBiala'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pSatyna'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pLus'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pc'): // typy obróbki: cięcie piłą, cięcie frezarką
            case this.translate.t('admpanel.materials.petG'): // typy obróbki: cięcie piłą, cięcie frezarką
                if (product.cut_mode === 'chainPolished' || product.cut_mode === 'laser') {
                    product.cutModeMessage = this.translate.t('admpanel.manualConfigurator.cutChain').toLowerCase() + ', ' + this.translate.t('admpanel.manualConfigurator.cutFrez').toLowerCase();
                }
                break;
            case this.translate.t('admpanel.materials.pTex'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
            case this.translate.t('admpanel.materials.pOhc'): // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                product.cutModeMessage = null;
                break;
        }

        this.changeDimensions(product);
    }

    changeDimensions(product) {
        // let selectedMaterial = this.materials.find(x => x.id === product.activeMaterial.id);
        // if (product.activeSubType !== null) {
        //     selectedMaterial = selectedMaterial.items.find(x => x.id === product.activeSubType.id)
        // }

        this.validateDimensions(product);

        // const dimensions = selectedMaterial.dimensions[this.thread.shop_id];

        // product.dimensionsWidthMessage = null;
        // product.dimensionsHeightMessage = null;

        // if (product.width > 0 && dimensions.max_width > 0 && product.width > dimensions.max_width) {
        //     product.dimensionsWidthMessage = this.translate.t('admpanel.manualConfigurator.maximumPossibleDimensionIs', {size: dimensions.max_width});
        // }

        // if (product.height > 0 && dimensions.max_height > 0 && product.height > dimensions.max_height) {
        //     product.dimensionsHeightMessage = this.translate.t('admpanel.manualConfigurator.maximumPossibleDimensionIs', {size: dimensions.max_height});
        // }
    }

    validateDimensions(product) {
        product.dimensionsWidthMessage = null;
        product.dimensionsHeightMessage = null;

        let width = product.width;
        let height = product.height;
        let cutMode = product.cut_mode;

        width = Math.round(width);
        height = Math.round(height);

        /*** Walidacja ***/
        const maxDimensions = Validator.getMaxDimensionsForCutMode(cutMode, product.activeMaterial ? product.activeMaterial.id : null, product.activeSubType ? product.activeSubType.id : null);

        if (width > maxDimensions.w) {
            product.dimensionsWidthMessage = this.translate.t('admpanel.manualConfigurator.maximumPossibleDimensionIs', {size: maxDimensions.w});
        }

        if (height > maxDimensions.h) {
            product.dimensionsHeightMessage = this.translate.t('admpanel.manualConfigurator.maximumPossibleDimensionIs', {size: maxDimensions.h});
        }
    }
}

let configuratorManualAdmComponent = {
    bindings: {
        'threadId': '<'
    },
    template: configuratorManualAdmHtml,
    controller: configuratorManualAdmController
};

export default configuratorManualAdmComponent;
